<template>
  <div class="vx-row">
    <div class="w-full vx-col">
        <vx-card  titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="mb-8 user-list-filters" :collapse-action="true">
            <div class="vx-row">
                <div class="w-full vx-col md:w-1/3 sm:w-1/2">
                    <label class="text-sm opacity-100 text-bold">Name</label>
                    <vs-input type="search"  placeholder="Search.." v-model="filters['name']" class="w-full mb-4 md:mb-0"/>
                </div>
            </div>
            <div class="mt-5 vx-row">
                <div class="w-full ml-auto vx-col">
                    <vs-button class="float-right mr-4" size="small"
                                color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
                </div>
            </div>
        </vx-card>
      <vx-card :title="'SAGE SUPPLIER TYPES'" class="">
        <template slot="actions">
          <vs-button v-can="'create-edit-sage-supplier'" @click.stop="onClickAdd" icon-pack="feather" icon="icon-plus" class="mr-4"  color="primary" type="filled">create</vs-button>
        </template>
        <div id="incoterms-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="sage_supplier_types">
              <template slot="thead">
                <vs-th width="75%">Name</vs-th>
                <vs-th width="25%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    <div class="justify-start vx-row" v-can="'create-edit-sage-supplier'">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button @click.stop="onClickUpdate(data[indextr].id)"  class="ml-3"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>
            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </div>
      </vx-card>
    </div>
    <add-new-sage-supplier-type-pop-up ref="addNewSageSupplierTypePopUp"/>
  </div>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import AddNewSageSupplierTypePopUp from "@/components/popups/settings/sage-supplier-type/AddNewSageSupplierTypePopUp";

  import Filter from '@/mixins/filter';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  import {defaultPagination, perPageList} from "@/constants/config";

  const SageSupplierTypeSettings = RepositoryFactory.get('sage_supplier_type')

  export default {
    name: "CcpItemSettings",
    data() {
      return {
        sage_supplier_types: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    components: {
      AddNewSageSupplierTypePopUp,
    },
    methods: {
      async refreshData() {
        await this.fetchSageSupplierTypes()
      },
      async fetchSageSupplierTypes() {
        await this.$vs.loading({
          container: '#incoterms-table',
          scale: 0.45
        })
        const {data} = await SageSupplierTypeSettings.getListOfSageSupplierTypes(this.page, this.filterQuery, this.perPage)
        this.sage_supplier_types =  data.data
         this.meta = data.meta
        this.$vs.loading.close('#incoterms-table > .con-vs-loading')
      },
      async onClickAdd() {
        await this.$refs.addNewSageSupplierTypePopUp.openPopup()
      },
      async onClickUpdate(id) {
        await this.$refs.addNewSageSupplierTypePopUp.openPopup(id)
      },
      filterQueryUpdate (){
        this.fetchSageSupplierTypes()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchSageSupplierTypes()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchSageSupplierTypes()
        }
      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
    },
    async mounted() {
      await this.fetchSageSupplierTypes()
    },
    mixins: [Filter, SuccessMessage, ErrorMessages],
     watch : {
      page(){
        this.fetchSageSupplierTypes()
      },
      perPage() {
        this.fetchSageSupplierTypes()
      }
    }
  }
</script>

<style scoped>

</style>
